import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { verifyMagicToken, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setError("Missing token");
      return;
    }
    verifyMagicToken(token)
      .then((data) => {
        setToken(data.token);
        setUser({ email: data.email, role: data.role });
        setStatus("ok");
        setTimeout(() => navigate("/admin", { replace: true }), 900);
      })
      .catch((err) => {
        setStatus("error");
        setError(err?.response?.data?.detail || "Sign-in failed");
      });
  }, [params, navigate, setUser]);

  return (
    <section className="min-h-[60vh] py-24 text-center">
      <div className="mx-auto max-w-md px-4">
        {status === "verifying" && (
          <>
            <p className="catalog-label mb-4">Signing you in</p>
            <p className="font-serif text-3xl">Verifying your link…</p>
          </>
        )}
        {status === "ok" && (
          <>
            <p className="catalog-label mb-4 text-[hsl(var(--vermillion))]">Signed in</p>
            <p className="font-serif text-3xl">Welcome back to the studio.</p>
          </>
        )}
        {status === "error" && (
          <>
            <p className="catalog-label mb-4 text-[hsl(var(--vermillion))]">Sign-in failed</p>
            <p className="font-serif text-2xl mb-6" data-testid="admin-verify-error">
              {error}
            </p>
            <Link
              to="/admin/login"
              className="inline-flex items-center gap-2 border border-[hsl(var(--ink))] px-5 py-2 font-mono text-xs uppercase tracking-widest hover:bg-[hsl(var(--ink))] hover:text-[hsl(var(--bg))] transition-colors"
            >
              Request a new link
            </Link>
          </>
        )}
      </div>
    </section>
  );
}
